import { create } from 'zustand'
import type { Session } from '@/bridge'

interface SessionState {
  session: Session | null
  setSession: (session: Session) => void
  setAccessToken: (accessToken: string) => void
}

export const useSession = create<SessionState>()((set) => ({
  session: null,
  setSession: (session) => set({ session }),
  setAccessToken: (accessToken) =>
    set((s) => (s.session ? { session: { ...s.session, accessToken } } : s)),
}))
